import './globals.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './backoffice/pages/Login';
import PasswordRecovery from './backoffice/pages/PasswordRecovery';
import ResetPassword from './backoffice/pages/ResetPassword';
import DashboardPage from './backoffice/pages/Dashboard';
import AdminManagementPage from './backoffice/pages/AdminManagement';
import { ProtectedRoute } from './backoffice/components/ProtectedRoute';
import { ConnectionStatus } from './backoffice/components/ConnectionStatus';
import { ToastProvider } from './backoffice/components/ToastProvider';
import ContactList from './backoffice/pages/Contacts';
import ContactDetails from './backoffice/pages/ContactDetail';
import Users from './backoffice/pages/Users';
import Posts from './backoffice/pages/Posts';
import AnimalSpeciesPage from './backoffice/pages/AnimalSpecies';
import MarketingManagementPage from './backoffice/pages/Marketing';

function App() {
  return (
    <ToastProvider>
      <ConnectionStatus />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot" element={<PasswordRecovery />} />
          <Route path="/reset" element={<ResetPassword />} />

          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }>
            <Route path="admin" element={<AdminManagementPage />} />
            <Route path="contacts" element={<ContactList />} />
            <Route path="contacts/:id" element={<ContactDetails />} />
            <Route path="users" element={<Users />} />
            <Route path="posts" element={<Posts />} />
            <Route path="species" element={<AnimalSpeciesPage />} />
            <Route path="marketing" element={<MarketingManagementPage/>} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
